var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "main-slides"
  }, [_c('swiper', {
    staticClass: "swiper",
    attrs: {
      "options": _vm.options
    }
  }, _vm._l(_vm.items, function (item, index) {
    return _c('swiper-slide', {
      key: index
    }, [_c('v-card', {
      staticClass: "slide-item",
      class: `slide-item--${item.code}`,
      attrs: {
        "tile": "",
        "flat": ""
      }
    }, [_c('img', {
      staticClass: "slide-item__image",
      attrs: {
        "src": `/images/main/slides/${item.code}.jpg`,
        "alt": item.text
      }
    }), _c('router-link', {
      staticClass: "slide-item__link",
      attrs: {
        "to": `/shop?category=${item.code}`
      }
    }, [_c('span', {
      staticClass: "d-sr-only"
    }, [_vm._v("자세히보기")])])], 1)], 1);
  }), 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }